// extracted by mini-css-extract-plugin
module.exports = {"text-limit-input":"TextLimitInput_text-limit-input__2d20G","text-limit-input__top":"TextLimitInput_text-limit-input__top__2GP4r"};